import React from 'react';

const Title = (props) => {
    return (
    <div className="pb-2 mt-4 mb-2 border-bottom">
        <h1>Check the Correctness of Text Modifications</h1>
    </div>
)}

export default Title;